import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  BrowserRouter as Router,
  Route,
  RouteProps,
  Routes,
  redirect,
} from "react-router-dom";
import { RouteList } from "./config/routes";
import "antd/dist/reset.css";
import "./index.css";
import "./antd.css";
import "./reset.scss";

export const MiddlewareRoute = (
  props: RouteProps & {
    title: string;
  }
) => {
  document.title = props.title;
  return <Route {...props} />;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <>
          {RouteList.map(({ component, path, title }) => {
            return <Route element={component} key={path} path={path} />;
          })}
          {/* {redirect("/index")} */}
        </>
      </Routes>
    </Router>
    {/* <App /> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
